vue
<template>
  <div>
    <!-- ANFRAGE ODER BESTANDSKUNDE -->
    <!--  -->
    <!-- {{ this.whatami }} -->
    <b-row class="pb-1">
      <b-col>
        <b-card title="Anfrage">
          <!-- {{ selectedInquiry }} -->
          <b-form-group label-for="v-inquiry">
            <v-select
              v-model="selectedInquiry"
              :options="inquiriesAcceptedEntries"
              label="email"
              :clearable="true"
              @input="turnInquiryFormFill"
            >
              <template v-slot:option="option">
                {{ option.id }} | {{ getFormattedDate(option.created_at) }} |
                {{ option.firstName }} {{ option.lastName }} |
                {{ option.email }}
              </template>
            </v-select>
          </b-form-group>
        </b-card>
      </b-col>
    </b-row>

    <!-- ANFRAGENACHRICHT -->
    <!--  -->
    <b-card
      v-if="inquiry"
      title="Anfragenachricht"
    >
      <b-row>
        <b-col>
          <b-form-group label-for="v-message">
            <b-form-textarea
              id="textarea-plaintext"
              plaintext
              :value="inquiry.customer.message"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <!-- Unternehmensinformationen -->
    <!--  -->
    <b-card title="Unternehmensinformationen">
      <b-row class="pb-2">
        <b-col cols="2">
          <b-form-group>
            <b-form-checkbox
              v-model="inquiry.customer.isOrganization"
              checked="false"
              name="check-button"
              switch
            >
              Gewerblich?
            </b-form-checkbox>
          </b-form-group></b-col>

        <b-col
          sm="12"
          md="12"
          lg="12"
          xl="10"
        >
          <b-form-group>
            <b-form-input
              v-model="inquiry.customer.organizationName"
              :disabled="!inquiry.customer.isOrganization"
              placeholder="Wayne Enterprise"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <b-card title="Kundeninformationen">
      <b-row class="">
        <b-col
          sm="12"
          md="12"
          lg="6"
          xl="4"
        >
          <b-form-group
            label="Anrede"
            label-for="v-salutation"
          >
            <v-select
              id="v-salutation"
              v-model="inquiry.customer.salutation"
              :clearable="false"
              :options="salutationOptions"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="">
        <b-col
          sm="12"
          md="12"
          lg="6"
          xl="6"
        >
          <b-form-group
            label="Vorname"
            label-for="v-firstname"
          >
            <validation-provider
              #default="{ errors }"
              name="Vorname"
              rules="required"
            >
              <b-form-input
                v-model="inquiry.customer.firstName"
                :state="errors.length > 0 ? false : null"
                placeholder="Bruce"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col
          sm="12"
          md="12"
          lg="6"
          xl="6"
        >
          <b-form-group
            label="Nachname"
            label-for="v-lastname"
          >
            <validation-provider
              #default="{ errors }"
              name="Nachname"
              rules="required"
            >
              <b-form-input
                v-model="inquiry.customer.lastName"
                :state="errors.length > 0 ? false : null"
                placeholder="Wayne"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          sm="12"
          md="12"
          lg="6"
          xl="6"
        >
          <b-form-group
            label="Email"
            label-for="v-email"
          >
            <validation-provider
              #default="{ errors }"
              name="Email"
              rules="required|email"
            >
              <b-form-input
                v-model="inquiry.customer.email"
                :state="errors.length > 0 ? false : null"
                type="email"
                placeholder="bruce@wayne.de"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="12"
          lg="6"
          xl="6"
        ><b-form-group
          label="Telefon"
          label-for="phoneNumber"
        >
          <validation-provider
            #default="{ errors }"
            rules="integer"
            name="Telefon"
          >
            <b-form-input
              v-model="inquiry.customer.phoneNumber"
              :state="errors.length > 0 ? false : null"
              placeholder="0525112345"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group></b-col>
      </b-row>
      <b-row>
        <b-col
          sm="12"
          md="12"
          lg="6"
          xl="6"
        >
          <b-form-group
            label="Handy"
            label-for="mobile"
          >
            <validation-provider
              #default="{ errors }"
              rules="integer"
              name="Handy"
            >
              <b-form-input
                v-model="inquiry.customer.mobileNumber"
                :state="errors.length > 0 ? false : null"
                placeholder="01701231231"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="12"
          lg="6"
          xl="6"
        >
          <b-form-group
            label="Fax"
            label-for="fax"
          >
            <validation-provider
              #default="{ errors }"
              rules="integer"
              name="Fax"
            >
              <b-form-input
                v-model="inquiry.customer.faxNumber"
                :state="errors.length > 0 ? false : null"
                placeholder="0525198765"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <!-- Adresse -->
    <!--  -->
    <b-card title="Adresse">
      <b-row class="">
        <b-col
          sm="9"
          md="9"
          lg="10"
          xl="6"
        >
          <b-form-group
            label="Strasse"
            label-for=""
          >
            <validation-provider
              #default="{ errors }"
              name="Strasse"
              rules="required"
            >
              <b-form-input
                v-model="inquiry.customer.street"
                :state="errors.length > 0 ? false : null"
                placeholder="Waynestrasse"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col
          sm="3"
          md="3"
          lg="2"
          xl="2"
        >
          <b-form-group
            label="Hausnummer"
            label-for=""
          >
            <validation-provider
              #default="{ errors }"
              name="Hausnummer"
              rules="required"
            >
              <b-form-input
                v-model="inquiry.customer.streetNumber"
                :state="errors.length > 0 ? false : null"
                placeholder="1"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="">
        <b-col
          sm="3"
          md="3"
          lg="2"
          xl="2"
        >
          <b-form-group
            label="PLZ"
            label-for=""
          >
            <validation-provider
              #default="{ errors }"
              name="PLZ"
              rules="required|digits:5"
            >
              <b-form-input
                v-model="inquiry.customer.zipCode"
                :state="errors.length > 0 ? false : null"
                placeholder="33104"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col
          sm="9"
          md="9"
          lg="10"
          xl="6"
        >
          <b-form-group
            label="Stadt"
            label-for=""
          >
            <validation-provider
              #default="{ errors }"
              name="Stadt"
              rules="required"
            >
              <b-form-input
                v-model="inquiry.customer.city"
                :state="errors.length > 0 ? false : null"
                placeholder="Paderborn"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col
          sm="9"
          md="9"
          lg="6"
          xl="6"
        >
          <b-form-group
            label="Land"
            label-for=""
          >
            <validation-provider
              #default="{ errors }"
              name="Land"
              rules="required"
            >
              <v-select
                id="v-country"
                v-model="inquiry.customer.country"
                :clearable="false"
                :options="getCountryOptions()"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import helper from '@/helper/helper'
import {
  BRow,
  BCol,
  BFormInput,
  BFormGroup,
  BFormCheckbox,
  BFormDatepicker,
  BInputGroup,
  BInputGroupPrepend,
  BFormInvalidFeedback,
  BCard,
  BCardText,
  BFormTextarea,
  BButton,
} from 'bootstrap-vue'

export default {
  setup() {
    const { getFormattedDate, getCountryOptions } = helper()

    return { getFormattedDate, getCountryOptions }
  },
  components: {
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BFormCheckbox,
    BFormDatepicker,
    BInputGroup,
    BInputGroupPrepend,
    BFormInvalidFeedback,
    BCard,
    BCardText,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    BButton,
    vSelect,
  },
  props: ['booking', 'inquiry'],
  data() {
    return {
      whatami: '',
      selectedInquiry: this.inquiry.customer,
      salutationOptions: ['Herr', 'Frau', 'Divers'],
    }
  },
  computed: {
    customerEntries() {
      return this.$store.getters.customerEntries
    },
    inquiriesAcceptedEntries() {
      return this.$store.getters.inquiriesAcceptedEntries
    },
  },
  mounted() {
    if (this.inquiry) {
      this.whatami = 'inquiry'
    } else {
      this.whatami = 'booking'
    }
  },
  methods: {
    turnInquiryFormFill(value) {
      console.log('Value: ', value)
      this.inquiryFormFill(value, true)
    },

    inquiryFormFill(value, isInquiry) {
      this.inquiry.isExistingCustomer = !isInquiry

      if (value === null) {
        // eslint-disable-next-line no-restricted-syntax
        this.inquiry.customer = {}
      } else {
        this.inquiry.customer = JSON.parse(JSON.stringify(value))

        if (isInquiry) {
          this.inquiry.customer.billingAddressDiffers = false
        }
      }
    },
  },
}
</script>
<style></style>
